import { matchRoutes, useLocation } from 'react-router-dom';
import { TabBar } from '.';
import type { NavigationItem } from '../../../tokens/navigationPaths';

/**
 * Bottom tab bar for the trading section. Uses `matchRoutes` against `tradingNavItems` so the currently
 * matched top-level destination drives the bar's highlighted item and its sub-tab bar (if any).
 */
export function MobileNavigationTabBar({
  navItems,
  layoutSectionLabel,
}: {
  navItems: NavigationItem[];
  layoutSectionLabel: string;
}) {
  const location = useLocation();
  const matches = matchRoutes(navItems, location);
  const currentTopLevelRoute = matches?.at(0)?.route as NavigationItem | undefined;

  if (!currentTopLevelRoute) {
    return null;
  }

  return <TabBar items={navItems} currentRoute={currentTopLevelRoute} layoutSectionLabel={layoutSectionLabel} />;
}
